enum ViewType {
	/** Dedicated for creating a new object */
	/** Default */
	Creating = 0,
	/** Dedicated for editing an existing object */
	Editing = 1,
	/** Dedicated for viewing an existing object (editable fields should be hidden) */
	Viewing = 2,
}

export default ViewType;